import React, {Component} from 'react';
import { connect } from "react-redux";
import Viewport from "./Viewport";
import {fetchModels, updateCaso, addComment, deleteAttachment, showAttachment, emptyComments, downloadAttachment, updateSteps} from '../../actions';
import {startLoading, endLoading} from '../../actions/loadingActions';
import { changeSubSection } from '../../actions/app';
import SideContainer from "./SideContainer";
import CommentContainer from "../comments/CommentContainer"
import Submenu from '../common/Submenu';
import _ from 'lodash'

import ModelosForm from '../forms/ModelosForm';
import CasoSummary from '../casos/CasoSummary';
import InfoContainer from '../casos/InfoContainer';
import NotesContainer from '../admin/notes/NotesContainer'
import AttachmentsContainer from '../attachments/AttachmentsContainer';


class Viewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSection: 'casodata',
            activePanel: null,
            activeStep: 0
        };
    }
    startLoading(){
        this.props.startLoading();
    }
    endLoading(){
        this.props.endLoading();
    }
    componentDidMount() {
        this.props.fetchModels(this.props.match.params.id);
        if(this.props.history.location.hash && this.props.history.location.hash !== '#comments'){
            this.setState({activeSection: this.props.history.location.hash.substring(1)})
        }
        if(this.props.history.location.hash === '#comments'){
            this.setState({activePanel: "comments"})
        }

    }
    componentDidUpdate(prevProps, prevState){
        if(this.props === prevProps){
            return false
        }
        if(this.props.caso && this.props.caso.status === 0 && this.state.first){
            this.props.changeSubSection('casodata');
            this.setState({first:false})
        }
    }
    componentWillUnmount() {
        this.setState({first:true})
        this.props.emptyComments()
    }
    changeSection(e){
        this.setState({ activeSection: e.target.id})
        this.props.history.replace(`#${e.target.id}`);
    }
    changeStep(step){
        this.setState({ activeStep: step})
    }
    openPanel(e){
        if(this.state.activePanel === e.target.id){
            this.setState({ activePanel: null})
        }else{
            this.setState({ activePanel: e.target.id})
        }
    }
    render() {
        return (
            <div className="justify-content-md-center">
                <div className="col-md-12 content-container">
                    <Submenu
                        isAdmin={this.props.user && this.props.user.admin}
                        activeSection={this.state.activeSection}
                        activePanel={this.state.activePanel}
                        changeSection={this.changeSection.bind(this)}
                        openPanel={this.openPanel.bind(this)}
                        caso={this.props.caso}
                        status={this.props.status}
                        updateCaso={this.props.updateCaso.bind(this)}
                        addComment={this.props.addComment.bind(this)}
                    />
                    <div className="row container-viewer">
                        <div className={!this.state.activePanel ? "col-md-12" : "col-md-7"}>
                        {{
                            'casodata': (
                                <CasoSummary
                                    caso={this.props.caso}
                                    addresses={this.props.addresses}
                                />
                            ),
                            'viewport': (
                                <Viewport
                                    caso={this.props.caso}
                                    activeSection={this.props.activeSection}
                                    startLoading={this.startLoading.bind(this)}
                                    endLoading={this.endLoading.bind(this)}
                                    activePart={this.state.activePart}
                                    models={this.props.caso.modelos}
                                    modelsObj={this.props.caso.modelosObj}
                                    changeStep={this.changeStep.bind(this)}
                                />
                            ),
                            'attachments': (
                                <AttachmentsContainer
                                    attachments={this.props.caso.attachments}
                                    casoId={this.props.caso.id}
                                    actionDelete={this.props.deleteAttachment.bind(this)}
                                    userId={this.props.userId}
                                    showAttachment={this.props.showAttachment}
                                    downloadAttachment={this.props.downloadAttachment}
                                    isAdmin={this.props.user && this.props.user.admin}
                                />
                            ),
                            'notes': (
                                <NotesContainer
                                    notes={this.props.caso.notes}
                                />
                            )
                        }[this.state.activeSection]}
                            {this.props.isAdmin && this.state.activeSection === 'modelos' ?
                                <ModelosForm casoId={this.props.caso.id} /> : null
                            }

                        </div>
                        {
                            this.state.activePanel && this.state.activePanel === 'comments' &&
                            <div className="col-md-5">
                                <CommentContainer />
                            </div>
                        }
                        {
                            this.state.activePanel && this.state.activePanel === 'info' &&
                            <div className="col-md-5">
                                <InfoContainer
                                    isAdmin={this.props.isAdmin}
                                    activeStep={this.state.activeStep}
                                    caso={this.props.caso}
                                />
                            </div>
                        }
                    </div>

                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        caso: state.caso,
        loading: state.loading,
        activeSection: state.activeSection,
        addresses: state.user.addresses,
        isAdmin: state.user.admin,
        userId: state.user.id
    };
}

export default connect(mapStateToProps,
    {
        fetchModels,
        startLoading,
        endLoading,
        changeSubSection,
        updateCaso,
        addComment,
        deleteAttachment,
        showAttachment,
        emptyComments,
        downloadAttachment
    })(Viewer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/Viewer.jsx